import moment from "moment";
import React, { useEffect, useState } from "react";
import { getBetsFromAccountLogs } from "../../service/AuthService";
export default function DetailModal({ isModalOpen, setIsModalOpen, id }) {
  const [betType, setBetType] = useState("all");
  const [matched, setMatched] = useState(""); // Used for Deleted filter
  const [logData, setLogData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const getData = async (id, TYPE = "ALL") => {
    const { response } = await getBetsFromAccountLogs(id);
 
      let response_ = response;
      let betResponseDTOList = response_.betResponseDTOList;
      let betResponseDTOList_ = [];
      betResponseDTOList.forEach((item) => {
        if (item.back_rate && item.event_type == "Casino") {
          item.type = "back";
          item.rate = item.back_rate;
        } else if (item.lay_rate && item.event_type == "Casino") {
          item.type = "lay";
          item.rate = item.lay_rate;
        }
        if (
          item.back_run &&
          (item.event_type == "Cricket" ||
            item.event_type == "Soccer" ||
            item.event_type == "Tennis")
        ) {
          item.type = "back";
          item.rate = item.back_run;
        } else if (
          item.lay_run &&
          (item.event_type == "Cricket" ||
            item.event_type == "Soccer" ||
            item.event_type == "Tennis")
        ) {
          item.type = "lay";
          item.rate = item.lay_run;
        }
        betResponseDTOList_.push(item);
      });
      response_.betResponseDTOList = betResponseDTOList_;

      if (TYPE == "ALL") {
        response_ = response;
      }
      if (TYPE == "BACK") {
        response_.betResponseDTOList = response_.betResponseDTOList.filter(
          (item) => item.type == "back"
        );
      }
      if (TYPE == "LAY") {
        response_.betResponseDTOList = response_.betResponseDTOList.filter(
          (item) => item.type == "lay"
        );
      }
      const filteredData_ = response_.betResponseDTOList?.filter((item) => {
        if (matched === "DELETED") return item?.deleted;

        if (betType === "back") return item?.back_rate || item?.back_run;
        if (betType === "lay") return item?.lay_rate || item?.lay_run;

        return true;
      });
      console.log(filteredData_);
      setFilteredData(filteredData_);
      setLogData(response_);
    
  };
  const [showModal, setShowModal] = useState(true); // Add this state

  const getRowStyle = (item) => {
    if (item?.lay_rate || item?.lay_run) {
      return { backgroundColor: "rgba(249, 148, 186, 1)" }; // pink for lay
    }
    if (item?.back_rate || item?.back_run) {
      return { backgroundColor: "rgba(114, 187, 239, 1)" }; // blue for back
    }
    return {};
  };
  useEffect(() => {
    getData(id, "ALL");
  }, [id]);

  return (
    <>
      {showModal && (
        <>
          <div classname="fade modal-backdrop show" />
          <div
            role="dialog"
            aria-modal="true"
            classname="fade modal show"
            tabIndex={-1}
            style={{
              display: "block",
              position: "absolute",
              width: "100%",
              marginTop: "15px",
            }}
          >
            
            <div classname="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title h4">Result</div>
                  {/* <button type="button" className="btn-close" aria-label="Close" /> */}
                  <button
                    onClick={() => setIsModalOpen(null)}
                    type="button"
                    // className="btn btn-danger btn-sm"
                    className="btn-close"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  {/* <div className="mt-1">
          Cricket -&gt; Indian Premier League -&gt; Delhi Capitals v Lucknow
          Super Giants -&gt; Normal
        </div> */}
                  <div className="mt-1">
                    {/* <div className="row">
            <div className="col-6">Winner: 103</div>
            <div className="col-6 text-end">Game Time: 24/03/2025 19:30:00</div>
          </div> */}
                  </div>
                  <div className="row mt-4 justify-content-between">
                    <div className="col-md-6">
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          id="soda-all"
                          name="bettype"
                          value="all"
                          checked={betType === "all" && matched !== "DELETED"}
                          onChange={(e) => {
                            setBetType(e.target.value);
                            setMatched("");
                          }}
                          className="custom-control-input"
                        />
                        All
                        <label className="form-check-label" htmlFor="all" />
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          id="soda-back"
                          name="bettype"
                          value="back"
                          checked={betType === "back"}
                          onChange={(e) => {
                            setBetType(e.target.value);
                            setMatched("");
                          }}
                          className="custom-control-input"
                        />
                        Back
                        <label className="form-check-label" htmlFor="back" />
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          id="soda-lay"
                          name="bettype"
                          value="lay"
                          checked={betType === "lay"}
                          onChange={(e) => {
                            setBetType(e.target.value);
                            setMatched("");
                          }}
                          className="custom-control-input"
                        />
                        Lay
                        <label className="form-check-label" htmlFor="lay" />
                      </div>
                      {/* <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="customRadio2"
                      name="bettype"
                      value="deleted"
                      checked={matched === "DELETED"}
                      onChange={() => {
                        setMatched("DELETED");
                        setBetType("all");
                      }}
                      className="custom-control-input"
                    />
                    Deleted
                    <label className="form-check-label" htmlFor="delete" />
                  </div> */}
                    </div>
                    <div className="col-md-6 text-end">
                      {/* <div>
            Total Bets: <span className="me-2">{filteredData?.length || 0}</span>
            Total Amount:
            <span className="me-2 text-danger">
              {filteredData?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0).toFixed(2)}
            </span>
          </div> */}
                    </div>
                  </div>

                  <div className="mt-2 table-responsive">
                    <table
                      role="table"
                      className="table table-bordered table-striped"
                    >
                      <thead>
                        <tr role="row">
                          <th role="columnheader">Nation</th>
                          <th role="columnheader" className="text-end">
                            Place Date
                          </th>
                          <th role="columnheader" className="text-end">
                            <b>Matched Date:</b>
                          </th>
                          <th role="columnheader" className="text-end">
                            Rate
                          </th>
                          <th role="columnheader" className="text-end">
                            Run
                          </th>
                          <th role="columnheader">Amount</th>
                          <th role="columnheader">
                            <b>W&amp;L</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody role="rowgroup">
                        {filteredData?.map((item, index) => (
                          <tr
                            key={index}
                            role="row"
                            style={{
                              ...getRowStyle(item),
                              fontSize: "x-small",
                              color: "black",
                            }}
                          >
                            <td role="cell">
                              {item?.runner_name || item?.event_name}
                            </td>
                            <td role="cell" className="text-end">
                              {moment(item?.created_date).format(
                                "DD MM YYYY hh:mm A"
                              )}
                            </td>
                            <td role="cell" className="text-end">
                              {moment(item?.created_date).format(
                                "DD MM YYYY hh:mm A"
                              )}
                            </td>
                            <td role="cell" className="text-end">
                              {item?.lay_rate ||
                                item?.back_rate ||
                                item?.lay_run ||
                                item?.back_run}
                            </td>
                            <td role="cell" className="text-end text-danger">
                              {item?.lay_run || item?.back_run}
                            </td>
                            <td role="cell">
                              <span>{item?.amount}</span>
                            </td>
                            <td role="cell">{item?.profit || item?.loss}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
